// Monthly interest rate
import { CURRENT_INTEREST } from '../../constants';

export const getMonthlyInterestRate = (interest = CURRENT_INTEREST) => interest / 100 / 12;
